.chips {
  display: flex;
  gap: 6px;
}

.chip {
  min-height: 44px;
  padding: 0 14px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: var(--surface);
  color: var(--ink-2);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.chip[aria-pressed='true'] {
  background: var(--accent-soft);
  color: var(--ink);
}
